import { DOCUMENTS_CATEGORIES } from 'utils/asset';

export enum TravelWalletFileKeys {
  vouchersFiles = 'voucherDocuments',
  eTicketsFiles = 'ticketDocuments',
  waiversFiles = 'waiverDocuments',
  miscFiles = 'miscDocuments',
  guestMiscDocuments = 'guestMiscDocuments',
  passportDocuments = 'passportDocuments',
  insuranceDocuments = 'insuranceDocuments',
}

export enum TravelWalletAdditionalKeys {
  additionalLinks = 'additionalLinks',
}

export const TravelWalletContentKeys = { ...TravelWalletFileKeys, ...TravelWalletAdditionalKeys };

export const FieldValuesKeys = [
  TravelWalletFileKeys.vouchersFiles,
  TravelWalletFileKeys.eTicketsFiles,
  TravelWalletFileKeys.waiversFiles,
  TravelWalletFileKeys.miscFiles,
  TravelWalletAdditionalKeys.additionalLinks,
];

export const TravelWalletDocumentTypes = {
  [TravelWalletFileKeys.eTicketsFiles]: DOCUMENTS_CATEGORIES.TICKET,
  [TravelWalletFileKeys.guestMiscDocuments]: DOCUMENTS_CATEGORIES.GUEST_MISC,
  [TravelWalletFileKeys.insuranceDocuments]: DOCUMENTS_CATEGORIES.INSURANCE,
  [TravelWalletFileKeys.miscFiles]: DOCUMENTS_CATEGORIES.MISC,
  [TravelWalletFileKeys.passportDocuments]: DOCUMENTS_CATEGORIES.PASSPORT,
  [TravelWalletFileKeys.vouchersFiles]: DOCUMENTS_CATEGORIES.VOUCHER,
  [TravelWalletFileKeys.waiversFiles]: DOCUMENTS_CATEGORIES.WAIVER,
};
